@import '../styles/palette.scss';

.buttonContainer {
  display: flex;
  padding-top: 16px;

  button {
    margin-top: 5px;
  }
}

.checkStedButton {
  margin-top: 2.1em;
}

.right {
  float: right;
}

strong {
  font-weight: 600 !important;
}

.duplikatPraksisstedList {
  max-height: 40em;
  overflow: auto;
}

.praksisstedtypekodePadding {
  display: inline-block;
  min-width: 12ch;
}

.praksisstedtypekodeNavn {
  display: inline-block;
}
